<app-badge [color]="badgeColor">{{name}}</app-badge>
